/**
 * @generated SignedSource<<3a913e14771c828ec1ddbea581502ba3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type composerImportAttributeDialogModelIDQuery$variables = {
  code: string;
  salesChannelId: string;
};
export type composerImportAttributeDialogModelIDQuery$data = {
  readonly modelIDByCode: string;
};
export type composerImportAttributeDialogModelIDQuery = {
  response: composerImportAttributeDialogModelIDQuery$data;
  variables: composerImportAttributeDialogModelIDQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "code"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "salesChannelId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "code"
      },
      {
        "kind": "Variable",
        "name": "salesChannelId",
        "variableName": "salesChannelId"
      }
    ],
    "kind": "ScalarField",
    "name": "modelIDByCode",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "composerImportAttributeDialogModelIDQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "composerImportAttributeDialogModelIDQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "eb431f6216bdebea3f24b66864722ee0",
    "id": null,
    "metadata": {},
    "name": "composerImportAttributeDialogModelIDQuery",
    "operationKind": "query",
    "text": "query composerImportAttributeDialogModelIDQuery(\n  $code: String!\n  $salesChannelId: String!\n) {\n  modelIDByCode(code: $code, salesChannelId: $salesChannelId)\n}\n"
  }
};
})();

(node as any).hash = "cb323ee3c769be460d36efae336242d7";

export default node;
